module.exports = __webpack_public_path__ + "img/cama1p.cf619d06.svg";